import L from "leaflet";
import AppState from "../core/app.js";
import Coordinate from "./coordinate.js";

class Identify {

    init() {

        AppState.map.on("click", async (e) => {
            if (AppState.measurementActive) return;
            const lng = e.latlng.lng;
            const lat = e.latlng.lat;

            // ========================================
            // UTM
            // ========================================

            let utm;

            try {

                utm = Coordinate.toUTM(lat, lng);

            } catch (err) {

                console.error(
                    "[IDENTIFY] UTM error:",
                    err
                );

                return;
            }


            // ========================================
            // CREATE UNIQUE POPUP
            // ========================================

            const popup = L.popup({
                closeButton: true,
                autoClose: true,
                closeOnClick: false
            })
                .setLatLng(e.latlng)
                .setContent(`
                    <table class="popup-table">

                        <tr>
                            <th colspan="2" class="identify-title">
                                <div>Data Update</div>
                                <div class="identify-date">
                                    Loading...
                                </div>
                            </th>
                        </tr>

                        <tr>
                            <th>E:</th>
                            <td>
                                ${Coordinate.format(
                                    utm.easting
                                )} m
                            </td>
                        </tr>

                        <tr>
                            <th>N:</th>
                            <td>
                                ${Coordinate.format(
                                    utm.northing
                                )} m
                            </td>
                        </tr>

                        <tr>
                            <th>Z:</th>
                            <td class="identify-elevation">
                                Loading...
                            </td>
                        </tr>

                    </table>
                `)
                .openOn(AppState.map);


            // ========================================
            // GET POPUP ELEMENT
            // ========================================

            const updatePopup =
                () => {

                    const element =
                        popup.getElement();

                    if (!element) {
                        return null;
                    }

                    return element;
                };


            // ========================================
            // DEM FILE DATE
            // ========================================

            try {

                const response =
                    await fetch("/api/dem-info");

                if (!response.ok) {
                    throw new Error(
                        `HTTP ${response.status}`
                    );
                }

                const data =
                    await response.json();

                console.log(
                    "[IDENTIFY] DEM info:",
                    data
                );


                const popupElement =
                    updatePopup();

                
                const dateElement =
                popupElement?.querySelector(
                    ".identify-date"
                );


                if (
                    dateElement &&
                    data.date
                ) {

                    const date =
                        new Date(data.date);

                    dateElement.textContent =
                        date.toLocaleDateString(
                            "id-ID",
                            {
                                day: "2-digit",
                                month: "long",
                                year: "numeric"
                            }
                        );
                }

            } catch (err) {

                console.error(
                    "[IDENTIFY] DEM info error:",
                    err
                );
            }


            // ========================================
            // DEM ELEVATION
            // ========================================

            try {

                const response =
                    await fetch(
                        `/api/elevation?lng=${lng}&lat=${lat}`
                    );

                if (!response.ok) {

                    throw new Error(
                        `HTTP ${response.status}`
                    );
                }

                const data =
                    await response.json();


                const popupElement =
                    updatePopup();

                const elevationElement =
                    popupElement?.querySelector(
                        ".identify-elevation"
                    );


                if (!elevationElement) {
                    return;
                }


                if (
                    data.elevation !== null &&
                    data.elevation !== undefined &&
                    Number.isFinite(
                        Number(data.elevation)
                    )
                ) {

                    const z =
                        Number(data.elevation);

                    elevationElement.textContent =
                        z < -300
                            ? "-"
                            : `${z.toFixed(2)} m`;

                } else {

                    elevationElement.textContent =
                        "-";
                }

            } catch (err) {

                console.error(
                    "[IDENTIFY] DEM elevation error:",
                    err
                );


                const popupElement =
                    updatePopup();

                const elevationElement =
                    popupElement?.querySelector(
                        ".identify-elevation"
                    );

                if (elevationElement) {

                    elevationElement.textContent =
                        "-";
                }
            }

        });
    }
}

export default new Identify();